export default __webpack_public_path__ + "static/media/close.03ec6776.svg";